export default "__VITE_ASSET__e3ce67e6__"